import React from 'react';
import styled from 'styled-components';

const OuterWrapper = styled.div`
  margin: 5px 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
`;

type WrapperProps = {
  hasError: boolean;
  disabled?: boolean;
};

const Wrapper = styled.div<WrapperProps>`
  width: 100%;
  padding: 16px 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 2px solid ${({ hasError }) => hasError ? '#EC4034' : '#FFF200'};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')}; 

  @media (orientation: portrait) and (max-width: 767px) {
    padding: 8px 0;
  }

  &:hover {
    border-bottom-color: #95D0DD;
  }

   &:focus-within {
    border-color: #95d0dd;
  }
`;

const Icon = styled.img`
  width: 20px;
  height: auto;
  margin: 0 8px 0 16px;
`;

type TextInputProps = {
  hasIcon?: boolean;
}

const TextInput = styled.input.attrs<TextInputProps>(() => ({
  type: 'text'
}))<TextInputProps>`
  font-size: 16px;
  line-height: 38px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.basic1000};
  outline: none;
  border: none;
  flex: 1;
    font-family: "Figtree", serif;
  margin: 0 16px 0 ${({ hasIcon }) => hasIcon ? '0' : '16px'};
    background-color: ${({ disabled }) => (disabled ? '#f5f5f5' : 'white')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'text')};

  ::placeholder {
    color: ${({ theme }) => theme.colors.basic400};
  }

  @media (orientation: portrait) and (max-width: 767px) {
    width: 100%;
  }
`;

const Error = styled.span`
  font-size: 14px;
  line-height: 18px;
  font-weight: 300;
  color: #EC4034;
  font-family: "Figtree", serif;
  margin-top: 5px;
  width: 100%;
  text-align: right;
`;

type InputProps = {
  label: string;
  value: string;
  handleChange: (value: string) => void;
  onBlur?: () => void;
  icon?: string;
  pattern?: string;
  type?: string;
  error?: string;
  disabled?: boolean;
  inputMode?: string;
}

const Input = ({ label, value, handleChange, onBlur, icon, pattern, type = 'text', error, disabled = false }: InputProps) => {
  const onChange = (e: any) => {
    e.preventDefault();
    handleChange(e.target.value);
  };

  return (
    <OuterWrapper>
      <Wrapper hasError={!!error} disabled={disabled}>
        {!!icon && <Icon src={icon} alt="Icono" />}
        <TextInput
          hasIcon={!!icon}
          type={type}
          pattern={pattern}
          placeholder={label}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
        />
      </Wrapper>
      {!!error && <Error>{error}</Error>}
    </OuterWrapper>
  )
};

export default Input;